var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8316 29.0459V13.5593C38.8316 9.58972 35.6137 6.37177 31.6441 6.37177H14.8541C10.8846 6.37177 7.66663 9.58972 7.66663 13.5593V33.7609C7.66663 37.1589 10.4212 39.9134 13.8191 39.9134H37.3941C38.188 39.9134 38.8316 39.2698 38.8316 38.4759C38.8316 37.682 38.188 37.0384 37.3941 37.0384H13.8191C12.009 37.0384 10.5416 35.571 10.5416 33.7609C10.5416 31.9508 12.009 30.4834 13.8191 30.4834H37.3941C38.188 30.4834 38.8316 29.8398 38.8316 29.0459ZM10.5416 28.5668V13.5593C10.5416 11.1775 12.4724 9.24677 14.8541 9.24677H31.6441C34.0259 9.24677 35.9566 11.1775 35.9566 13.5593V27.6084H13.8191C12.6579 27.6112 11.5214 27.9435 10.5416 28.5668Z",
    fill: "#787486"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3816 33.7609C12.3816 32.967 13.0252 32.3234 13.8191 32.3234H35.0366C35.8305 32.3234 36.4741 32.967 36.4741 33.7609C36.4741 34.5548 35.8305 35.1984 35.0366 35.1984H13.8191C13.0252 35.1984 12.3816 34.5548 12.3816 33.7609Z",
    fill: "#787486"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualIcon);
export default __webpack_public_path__ + "static/media/manualIcon.0eed2726279860fd50da9dc5ceab774b.svg";
export { ForwardRef as ReactComponent };